export default __webpack_public_path__ + "c007f3f9fda7cc1cf68ba614be6a2807.png";